var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g2, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 667,
    viewBox: "0 0 1000 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4405_6576)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4405_6576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -2,
    width: 1000,
    height: 667
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -1.99988H1000V664.667H0V-1.99988Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4405_6576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.056 490.188C705.056 350.35 591.696 236.992 451.862 236.992C312.026 236.992 198.666 350.35 198.666 490.188C198.666 518.085 203.19 544.924 211.524 570.024H692.197C700.532 544.924 705.056 518.085 705.056 490.188Z",
    fill: "#0095FF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.974 150.942C803.974 191.801 770.851 224.923 729.993 224.923C689.134 224.923 656.011 191.801 656.011 150.942C656.011 110.083 689.134 76.9607 729.993 76.9607C770.851 76.9607 803.974 110.083 803.974 150.942Z",
    fill: "#0095FF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.889 570.758H882.573",
    stroke: "#0482C6",
    strokeWidth: 1.98133,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.889 124.469H343.361",
    stroke: "#444444",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.928 421.72H110.32C106.768 421.72 103.888 418.84 103.888 415.288V98.6134C103.888 95.0601 106.768 92.1814 110.32 92.1814H336.928C340.482 92.1814 343.36 95.0601 343.36 98.6134V415.288C343.36 418.84 340.482 421.72 336.928 421.72Z",
    stroke: "#444444",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.411 108.654C135.411 111.142 133.393 113.16 130.905 113.16C128.417 113.16 126.4 111.142 126.4 108.654C126.4 106.166 128.417 104.149 130.905 104.149C133.393 104.149 135.411 106.166 135.411 108.654Z",
    stroke: "#444444",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.92 108.654C152.92 111.142 150.903 113.16 148.415 113.16C145.927 113.16 143.909 111.142 143.909 108.654C143.909 106.166 145.927 104.149 148.415 104.149C150.903 104.149 152.92 106.166 152.92 108.654Z",
    stroke: "#444444",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.43 108.654C170.43 111.142 168.413 113.16 165.925 113.16C163.437 113.16 161.419 111.142 161.419 108.654C161.419 106.166 163.437 104.149 165.925 104.149C168.413 104.149 170.43 106.166 170.43 108.654Z",
    stroke: "#444444",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.31 457.892H156.703C153.151 457.892 150.271 455.013 150.271 451.46V151.639C150.271 148.087 153.151 145.207 156.703 145.207H383.31C386.862 145.207 389.742 148.087 389.742 151.639V451.46C389.742 455.013 386.862 457.892 383.31 457.892Z",
    fill: "#DADBE2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M671.407 518.824H544.814C536.178 518.824 529.97 510.374 532.417 501.945L592.871 293.556C594.494 287.964 599.539 284.126 605.268 284.126H731.862C740.498 284.126 746.705 292.577 744.261 301.004L683.806 509.393C682.183 514.985 677.137 518.824 671.407 518.824Z",
    fill: "#212425"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M653.989 518.824H543.72C535.086 518.824 528.877 510.374 531.323 501.945L591.776 293.556C593.4 287.964 598.445 284.126 604.175 284.126H714.444C723.08 284.126 729.285 292.577 726.841 301.004L666.386 509.393C664.763 514.985 659.718 518.824 653.989 518.824Z",
    fill: "#52585B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M632.767 518.824H498.776C492.527 518.824 487.461 513.757 487.461 507.508C487.461 501.261 492.527 496.195 498.776 496.195H632.767C639.016 496.195 644.084 501.261 644.084 507.508C644.084 513.757 639.016 518.824 632.767 518.824Z",
    fill: "#3D5AF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M632.767 518.824H498.776C492.527 518.824 487.461 513.757 487.461 507.508C487.461 501.261 492.527 496.195 498.776 496.195H632.767C639.016 496.195 644.084 501.261 644.084 507.508C644.084 513.757 639.016 518.824 632.767 518.824Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M600.769 674.919H589.371V517.061H600.769V674.919Z",
    fill: "#212425"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M667.845 518.824H533.854C527.605 518.824 522.539 513.757 522.539 507.508C522.539 501.261 527.605 496.195 533.854 496.195H667.845C674.095 496.195 679.161 501.261 679.161 507.508C679.161 513.757 674.095 518.824 667.845 518.824Z",
    fill: "#212425"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M532.315 240.429L549.684 235.709",
    stroke: "#3D5AF5",
    strokeWidth: 0.714667,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M532.315 240.429L549.684 235.709",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 0.714667,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M539.866 212.564C539.866 212.564 510.96 223.248 531.074 270.557C533.527 276.321 540.926 278.07 546.028 274.438L566.792 259.65",
    fill: "#FFAAB3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M546.716 261.825C547.835 262.767 565.451 300.45 565.451 300.45L597.726 288.11L560.361 225.942L546.716 261.825Z",
    fill: "#FFAAB3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M524.732 246.047C524.745 246.768 523.217 252.421 522.291 255.775C521.99 256.856 522.996 257.844 524.073 257.532L530.465 255.676L524.732 246.047Z",
    fill: "#FFAAB3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M551.302 270.68L560.362 263.335L558.896 286.529L551.302 270.68Z",
    fill: "#E2717D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M559.116 243.472L574.821 250.755C574.821 250.755 599.964 228.611 582.003 208.807C564.041 189.004 533.952 213.763 533.952 213.763L554.938 238.257L559.116 243.472Z",
    fill: "#212425"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M529.707 240.45C528.72 241.199 528.525 242.608 529.274 243.594C530.025 244.581 531.432 244.776 532.42 244.027C533.407 243.276 533.6 241.869 532.851 240.882C532.102 239.894 530.693 239.701 529.707 240.45Z",
    fill: "#3D5AF5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M529.707 240.45C528.72 241.199 528.525 242.608 529.274 243.594C530.025 244.581 531.432 244.776 532.42 244.027C533.407 243.276 533.6 241.869 532.851 240.882C532.102 239.894 530.693 239.701 529.707 240.45Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M528.828 260.562C528.828 260.562 531.665 260.781 533.26 256.198",
    stroke: "#3D5AF5",
    strokeWidth: 0.894667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M528.828 260.562C528.828 260.562 531.665 260.781 533.26 256.198",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 0.894667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M529.066 230.313C529.066 230.313 531.526 227.975 534.709 229.825",
    stroke: "#3D5AF5",
    strokeWidth: 0.894667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M529.066 230.313C529.066 230.313 531.526 227.975 534.709 229.825",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 0.894667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M553.657 236.363C552.912 241.79 556.708 246.795 562.135 247.54C567.562 248.286 572.567 244.491 573.312 239.062C574.057 233.635 570.263 228.63 564.836 227.885C559.409 227.14 554.404 230.936 553.657 236.363Z",
    fill: "#FFAAB3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M533.952 213.763C533.952 213.763 523.328 221.631 523.038 229.713L543.68 216.786L533.952 213.763Z",
    fill: "#212425"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M623.587 194.634C622.571 206.88 611.819 215.985 599.571 214.967C587.324 213.95 578.22 203.197 579.238 190.951C580.255 178.705 591.007 169.6 603.254 170.618C615.502 171.634 624.605 182.388 623.587 194.634Z",
    fill: "#212425"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M577.734 204.614L584.438 212.407L587.699 210.09L581.205 202.171L577.734 204.614Z",
    fill: "#0095FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M486.805 650.633L433.157 680.785C433.157 680.785 532.635 681.484 532.618 680.577C532.599 679.673 525.931 649.772 525.931 649.772L486.805 650.633Z",
    fill: "#F5BB3D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M523.004 649.901L520.198 620.626L483.662 618.856L486.805 650.634L523.004 649.901Z",
    fill: "#FFAAB3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M443.72 472.061L470.766 628.49L532.869 629.288L516.039 530.24L443.72 472.061Z",
    fill: "#CDCCD7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M560.798 625.91L537.574 684.16C537.574 684.16 617.413 621.812 616.85 621.103C616.286 620.394 591.516 601.911 591.516 601.911L560.798 625.91Z",
    fill: "#F5BB3D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M623.045 628.891L543.769 691.949L537.574 684.16L616.85 621.104L623.045 628.891Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M589.266 603.787L572.086 580.075L539.439 599.453L560.797 625.909L589.266 603.787Z",
    fill: "#FFAAB3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M647.906 429.911L645.975 429.996L647.222 421.264H583.948L582.004 432.787L459.399 438.138C459.399 438.138 422.576 439.789 423.361 475.59C423.599 486.455 427.548 496.913 434.033 505.632L530.477 620.333L585.595 580.986L512.508 497.236L607.376 496.83C642.552 496.652 654.881 464.39 647.906 429.911Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M512.51 497.236C512.51 497.236 501.176 482.589 476.587 475.795",
    stroke: "#CDCCD7",
    strokeWidth: 1.84933,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M582.005 432.788H622.287",
    stroke: "#CDCCD7",
    strokeWidth: 1.84933,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M491.674 392.478L574.331 294.907L615.789 329.546L529.932 425.312C519.809 436.797 501.872 436.681 491.897 425.069C483.867 415.719 483.773 401.934 491.674 392.478Z",
    fill: "#027FD9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M470.147 320.873L483.138 338.509L455.49 357.384L428.38 328.69L466.566 313.698L470.147 320.873Z",
    fill: "#FFAAB3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M468.231 325.681L467.514 319.669L470.147 320.872L461.876 304.294C461.193 302.925 460.252 301.672 459.001 300.792C456.124 298.762 453.815 299.652 451.758 299.43C448.31 299.06 449.377 300.093 449.324 303.559C445.72 303.618 438.284 305.232 434.195 289.314C433.321 285.909 429.791 283.82 426.381 284.673C421.221 285.961 430.166 283.581 429.916 285.909C429.905 286.006 429.916 286.105 429.911 286.2C428.684 285.059 426.928 284.534 425.178 284.97C423.033 285.505 421.541 287.319 421.316 289.4C421.287 289.673 421.285 289.953 421.301 290.233C420.493 290.019 419.63 289.977 418.763 290.193C416.617 290.728 415.125 292.543 414.901 294.623C414.838 295.206 414.876 295.807 415.026 296.408C415.08 296.624 415.142 296.82 415.198 297.034C415.106 297.051 415.015 297.051 414.923 297.072C412.776 297.607 412.672 298.573 412.448 300.653C412.385 301.235 412.423 301.837 412.573 302.438C413.695 306.95 414.81 308.757 416.49 312.134L416.48 312.136C416.48 312.136 416.515 312.198 416.563 312.29C417.362 313.88 418.226 315.327 419.143 316.654C424.344 324.957 437.405 341.211 452.26 344.878C472.022 349.758 468.231 325.681 468.231 325.681Z",
    fill: "#FFAAB3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M404.469 277.348L404.568 280.315C404.592 281.246 404.929 282.141 405.523 282.858L442.669 327.433C443.722 328.703 445.744 330.334 447.393 330.294L463.692 329.882C465.474 329.839 467.413 328.143 468.238 325.958L419.327 278.951L404.469 277.348Z",
    fill: "#3D5AF5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M404.469 277.348L404.568 280.315C404.592 281.246 404.929 282.141 405.523 282.858L442.669 327.433C443.722 328.703 445.744 330.334 447.393 330.294L463.692 329.882C465.474 329.839 467.413 328.143 468.238 325.958L419.327 278.951L404.469 277.348Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M404.884 278.478L445.49 326.133C446.312 327.097 447.521 327.646 448.788 327.631L466.509 327.424C467.878 327.408 468.606 325.799 467.713 324.762L427.188 277.615C426.087 276.335 424.475 275.607 422.786 275.626L406.091 275.822C404.726 275.838 403.998 277.438 404.884 278.478Z",
    fill: "#3D5AF5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M404.884 278.478L445.49 326.133C446.312 327.097 447.521 327.646 448.788 327.631L466.509 327.424C467.878 327.408 468.606 325.799 467.713 324.762L427.188 277.615C426.087 276.335 424.475 275.607 422.786 275.626L406.091 275.822C404.726 275.838 403.998 277.438 404.884 278.478Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M412.069 280.109L448.881 323.311C449.467 323.997 450.327 324.388 451.228 324.377L461.315 324.259C462.529 324.245 463.175 322.817 462.383 321.895L426.393 280.025C425.415 278.887 423.983 278.239 422.484 278.259L412.859 278.372C411.965 278.38 411.49 279.428 412.069 280.109Z",
    fill: "#E6E5EC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M455.612 299.481L446.649 298.11C442.881 297.533 439.911 301.267 441.318 304.809C441.771 305.949 442.633 306.88 443.734 307.418L459.851 315.305L457.474 304.92L455.612 299.481Z",
    fill: "#FFAAB3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4405_6576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 412,
    y: 179,
    width: 147,
    height: 146
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M412.07 179.669H558.844V324.259H412.07V179.669Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4405_6576)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.490005
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4405_6576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 412,
    y: 179,
    width: 147,
    height: 146
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M412.07 278.741L484.156 179.669L558.844 306.103L461.315 324.259L412.07 278.741Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4405_6576)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4405_6576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -57088,
    y: -56108,
    width: 113852,
    height: 113852
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-57087.9 -56107.7H56763V57743.3H-57087.9V-56107.7Z",
    fill: "url(#paint0_linear_4405_6576)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4405_6576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.086 278.728L484.172 179.656L558.86 306.09L461.33 324.246L412.086 278.728Z",
    fill: "url(#paint1_linear_4405_6576)"
  })))))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M491.027 424.054L439.832 357.92L482.582 324.888L531.326 393.76C540.363 406.117 536.39 423.609 522.902 430.85V430.852C512.044 436.682 498.562 433.805 491.027 424.054Z",
    fill: "#027FD9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M558.843 306.104L554.629 296.372L592.826 271.182L602.367 291.674L558.843 306.104Z",
    fill: "#027FD9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M559.86 302.228C550.8 306.104 542.51 329.284 542.416 344.105C542.248 371.074 559.46 374.844 559.46 374.844L583.947 421.265H647.223L635.957 315.996C632.373 293.007 599.018 284.482 599.018 284.482L559.86 302.228Z",
    fill: "#0095FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M605.356 491.622C603.759 493.987 603.862 497.11 605.611 499.363C607.993 502.431 612.494 502.791 615.331 500.136L617.655 497.963C620.527 500.85 623.71 507.471 613.693 523.454C612.008 526.143 612.821 529.689 615.51 531.374C617.61 532.689 620.232 532.482 622.084 531.044C622.169 530.978 622.242 530.893 622.325 530.822C622.356 532.7 623.3 534.522 625.009 535.596C627.108 536.909 629.733 536.702 631.585 535.265C631.826 535.078 632.054 534.862 632.268 534.631C632.723 535.448 633.36 536.176 634.208 536.707C636.307 538.022 638.932 537.816 640.784 536.379C641.301 535.976 641.756 535.477 642.125 534.89C642.257 534.68 642.368 534.475 642.496 534.267C642.582 534.326 642.651 534.4 642.741 534.456C644.842 535.771 647.465 535.564 649.315 534.128C649.835 533.724 650.29 533.226 650.658 532.639C653.424 528.226 655.493 524.017 656.912 520.037L656.921 520.044C656.921 520.044 656.943 519.967 656.98 519.858C657.642 517.978 658.137 516.156 658.495 514.385C660.569 506.055 663.613 490.003 660.738 476.308L617.414 473.777L605.356 491.622Z",
    fill: "#FFAAB3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M681.106 401.27L666.127 483.55L612.985 473.828L631.638 391.539C634.791 376.559 650.457 367.822 664.859 373.015C676.454 377.197 683.325 389.145 681.106 401.27Z",
    fill: "#0095FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M633.854 408.7L587.989 318.238C581.37 305.183 586.528 289.233 599.536 282.525C612.932 275.62 629.386 281.195 635.821 294.823L678.967 386.191C685.621 399.978 678.55 416.466 663.976 421.148C652.245 424.919 639.502 419.655 633.854 408.7Z",
    fill: "#0095FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M593.577 329.258L628.879 398.889L625.044 420.627",
    stroke: "#0482C6",
    strokeWidth: 2.00933,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4405_6576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 144,
    width: 240,
    height: 315
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M156.432 144C152.88 144 150 146.897 150 150.472V452.212C150 455.788 152.88 458.685 156.432 458.685H383.039C386.592 458.685 389.472 455.788 389.472 452.212V150.472C389.472 146.897 386.592 144 383.039 144H156.432Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4405_6576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.805 333.112L324.121 410.587C328.401 419.242 338.326 423.752 347.742 421.322C359.217 418.358 365.529 406.361 361.395 395.372L331.171 315.002L285.805 333.112Z",
    fill: "#FFAAB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.596 318.1L314.5 401.637H364.5L329.136 297.187C323.65 286.634 312.549 281.55 298.382 281.953L300.334 283.089C284.342 286.073 274.598 302.523 279.596 318.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.382 281.952L222.63 281.929C211.462 281.929 220.732 290.435 219.558 301.613L207.869 456.115L331.608 445.847L320.128 301.994C319.136 290.651 309.696 281.952 298.382 281.952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 399.625L315.022 313.215",
    stroke: "#CDCCD7",
    strokeWidth: 1.84933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.562 298.661L166 401.637H212L243.946 314.439C246.427 302.795 241.074 290.884 230.746 285.071C216.55 277.08 198.61 283.466 192.562 298.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 399.625L238 317.1",
    stroke: "#CDCCD7",
    strokeWidth: 1.84933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.685 229.358C293.477 235.423 298.195 240.512 304.221 240.721C310.248 240.93 315.304 236.183 315.512 230.116C315.72 224.051 311.003 218.964 304.976 218.755C298.948 218.544 293.893 223.291 293.685 229.358Z",
    fill: "#535775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.277 246.37L290.491 285.541C290.201 296.553 282.667 297.118 271.9 296.744C262.708 296.424 254.933 293.442 254.109 284.222L253.536 241.84L291.277 246.37Z",
    fill: "#FFAAB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.656 278.137L262.178 255.082L291.123 255.736L290.656 278.137Z",
    fill: "#E2717D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.566 261.364L287.827 261.896C299.286 262.293 308.795 253.063 308.814 241.525L308.866 213.202C308.89 198.74 297.511 186.865 283.15 186.366C268.447 185.855 253.54 197.347 253.032 212.142L253.536 241.84C253.696 252.411 262.066 260.999 272.566 261.364Z",
    fill: "#FFAAB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5 205.39C288 163.122 243 187.275 245.042 206.985C243.79 217.757 247.673 233.084 256.437 228.414C256.437 228.414 272.407 229.276 266.826 207.739C266.826 207.739 275.357 193.033 289.5 196.836",
    fill: "#212425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.428 239.072H295.404L291.904 238.95C291.512 238.937 291.205 238.605 291.218 238.212C291.233 237.819 291.586 237.549 291.953 237.522L294.665 237.618L294.318 232.651C294.29 232.258 294.584 231.917 294.977 231.891C295.329 231.861 295.706 232.159 295.733 232.553L296.134 238.309C296.15 238.51 296.078 238.708 295.938 238.853C295.805 238.993 295.62 239.072 295.428 239.072Z",
    fill: "#3D5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.428 239.072H295.404L291.904 238.95C291.512 238.937 291.205 238.605 291.218 238.212C291.233 237.819 291.586 237.549 291.953 237.522L294.665 237.618L294.318 232.651C294.29 232.258 294.584 231.917 294.977 231.891C295.329 231.861 295.706 232.159 295.733 232.553L296.134 238.309C296.15 238.51 296.078 238.708 295.938 238.853C295.805 238.993 295.62 239.072 295.428 239.072Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 228.335C299.27 229.605 300.258 230.669 301.518 230.712C302.779 230.756 303.837 229.763 303.881 228.494C303.925 227.224 302.937 226.16 301.675 226.117C300.415 226.073 299.358 227.066 299.314 228.335Z",
    fill: "#212425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.853 227.693C280.81 228.962 281.797 230.027 283.057 230.069C284.318 230.114 285.377 229.121 285.42 227.851C285.464 226.583 284.477 225.518 283.216 225.475C281.954 225.431 280.897 226.424 280.853 227.693Z",
    fill: "#212425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.935 214.064C281.935 214.064 287.854 213.373 287.883 216.551C287.883 216.551 287.858 218.706 282.695 219.177C277.531 219.648 276.195 219.16 275.743 217.141C275.291 215.122 279.162 214.107 281.935 214.064Z",
    fill: "#212425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.194 214.627C303.194 214.627 298.319 214.003 297.892 216.994C297.892 216.994 297.64 219.019 301.91 219.439C306.178 219.859 307.575 219.13 307.995 217.493C308.47 215.64 305.514 214.655 303.194 214.627Z",
    fill: "#212425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.058 242.305H282.205C282.205 242.305 283.109 249.114 292.05 248.015C298.054 247.278 298.058 242.305 298.058 242.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.597 281.93L246.293 281.936C246.293 281.936 249.497 304.066 280.149 302.262C284.145 302.027 288.156 301.295 291.753 299.527C297.31 296.795 302.425 291.737 295.597 281.93Z",
    fill: "#FFAAB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.466 236.031L253.66 251.014L256.326 233.165L249.466 236.031Z",
    fill: "#212425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.323 228.035C239.114 234.1 243.831 239.189 249.859 239.398C255.886 239.607 260.94 234.86 261.15 228.793C261.356 222.728 256.64 217.641 250.612 217.432C244.586 217.221 239.531 221.969 239.323 228.035Z",
    fill: "#FFAAB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.938 232.526H253.915C253.523 232.514 253.217 232.184 253.229 231.791C253.23 231.757 253.307 228.468 251.334 226.666C250.238 225.666 248.678 225.296 246.694 225.548C246.318 225.602 245.95 225.324 245.899 224.932C245.85 224.542 246.123 224.184 246.513 224.134C248.93 223.823 250.875 224.315 252.295 225.617C254.755 227.868 254.653 231.678 254.647 231.838C254.634 232.223 254.319 232.526 253.938 232.526Z",
    fill: "#3D5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.938 232.526H253.915C253.523 232.514 253.217 232.184 253.229 231.791C253.23 231.757 253.307 228.468 251.334 226.666C250.238 225.666 248.678 225.296 246.694 225.548C246.318 225.602 245.95 225.324 245.899 224.932C245.85 224.542 246.123 224.184 246.513 224.134C248.93 223.823 250.875 224.315 252.295 225.617C254.755 227.868 254.653 231.678 254.647 231.838C254.634 232.223 254.319 232.526 253.938 232.526Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.685 229.358C235.477 235.423 240.195 240.512 246.221 240.721C252.248 240.93 257.304 236.183 257.512 230.116C257.72 224.051 253.003 218.964 246.976 218.755C240.948 218.544 235.893 223.291 235.685 229.358Z",
    fill: "#535775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.99 202.371H247.99V202.298L247.979 202.225L246.99 202.371ZM292.908 187.585C293.357 187.906 293.982 187.803 294.303 187.354C294.625 186.904 294.521 186.28 294.072 185.958L292.908 187.585ZM247.99 219.48V202.371H245.99V219.48H247.99ZM247.979 202.225C247.538 199.224 248.822 195.986 251.492 192.952C254.154 189.928 258.112 187.21 262.749 185.307C272.04 181.493 283.777 181.052 292.908 187.585L294.072 185.958C284.213 178.905 271.701 179.47 261.989 183.456C257.124 185.453 252.893 188.333 249.991 191.631C247.098 194.918 245.443 198.725 246.001 202.517L247.979 202.225ZM299 252.181H305.5V250.181H299V252.181ZM305.5 252.181C306.853 252.181 308.001 251.5 308.833 250.603C309.664 249.707 310.246 248.531 310.481 247.351L308.519 246.961C308.354 247.793 307.936 248.63 307.367 249.243C306.799 249.856 306.147 250.181 305.5 250.181V252.181ZM310.481 247.351C310.692 246.288 310.987 243.894 311.208 241.459C311.429 239.034 311.587 236.446 311.498 235.017L309.502 235.141C309.58 236.396 309.438 238.839 309.217 241.278C308.996 243.708 308.708 246.011 308.519 246.961L310.481 247.351Z",
    fill: "#535775"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.5,
    cy: 251.181,
    rx: 4.5,
    ry: 3.52239,
    fill: "#535775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.307 485.734H121.277V399.708H414.307V485.734Z",
    fill: "#183962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.949 428.449C293.949 438.899 285.532 447.372 275.148 447.372C264.764 447.372 256.347 438.899 256.347 428.449C256.347 417.998 264.764 409.527 275.148 409.527C285.532 409.527 293.949 417.998 293.949 428.449Z",
    fill: "#E76D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3 422.203L281.378 434.359",
    stroke: "white",
    strokeWidth: 2.02933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.377 422.203L269.299 434.359",
    stroke: "white",
    strokeWidth: 2.02933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.0700073
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.651 229.544C469.651 229.544 307.743 413.576 204 531.496L479.24 533.227L469.651 229.544Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4405_6576",
    x1: 423.924,
    y1: 299.217,
    x2: 522.157,
    y2: 242.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753266,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4405_6576",
    x1: 423.917,
    y1: 299.222,
    x2: 522.15,
    y2: 242.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753266,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4405_6576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 666.667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.a97dcfbe94d8224263f932549606825b.svg";
export { ForwardRef as ReactComponent };